import { useEffect, useState } from 'react'
import { ToastContent, toast } from 'react-toastify'
import { getUserFeatureFlagData, updateFeatureFlagData } from 'services/featureFlagService'
import { useForm } from "react-hook-form"
import { DataTable, DataTableValue } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { getUsersData } from 'services/userService';
import { InputText } from 'primereact/inputtext';
import { FilterMatchMode } from 'primereact/api';
import FeatureFlagDataTable from 'components/FeatureFlagDataTable';
import { handleLoader, handleNotFound } from 'redux/counterSlice';
import { useDispatch } from 'react-redux';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';


const FlagSettings = () => {

    const [flagArray, setFlagArray] = useState<DataTableValue[]>([])
    const [userList, setUserList] = useState<DataTableValue[]>([])
    const [user, setUser] = useState<{ [s: string]: any }>()
    const [globalFilterValue, setGlobalFilterValue] = useState('')
    const [filters, setFilters] = useState<{ [s: string]: any }>()
    const dispatch = useDispatch();
    const fetchUserData = async () => {
        dispatch(handleLoader(true));
        try {
            const { result, error } = await getUsersData()
            if (error) {
                throw error
            }
            if (result.error) {
                throw result.error
            }
            dispatch(handleLoader(false));
            setUserList(result)
        } catch (error) {
            dispatch(handleLoader(false));
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    const {
        register,
        handleSubmit,
        setValue
    } = useForm()

    const onSubmit = async () => {
        dispatch(handleLoader(true));
        try {
            const flagData = flagArray.reduce((acc: any, item: any) => {
                acc[item.key] = item.enabled;
                return acc;
            }, {});
            const { result, error } = await updateFeatureFlagData({ user_name: "", flags: flagData })
            if (error) {
                throw error
            }
            if (result.error) {
                throw result.error
            }
            getFeatureFlagData(user?.email ?? "")
            // dispatch(handleLoader(false));
            toast.success(result.message, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        } catch (error) {
            dispatch(handleLoader(false));
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    const handleUserListChange = async (e: DropdownChangeEvent) => {
        try {
            setUser(e.value)
            getFeatureFlagData(e.value.username)
        } catch (error) {
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    const getFeatureFlagData = async (username: string) => {
        dispatch(handleLoader(true));
        try {
            const { result, error } = await getUserFeatureFlagData(username)
            if (error) {
                throw error
            }
            if (result.error) {
                throw result.error
            }
            dispatch(handleLoader(false));
            result.flags.forEach((flag: { [s: string]: any }) => {
                setValue(flag.key, flag.enabled)
            });
            setFlagArray(result.flags)
        } catch (error) {
            dispatch(handleLoader(false));
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e?.target?.value;
        let _filters = { ...filters };

        _filters['global']!.value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        setGlobalFilterValue('');
    };


    useEffect(() => {
        dispatch(handleNotFound(false))
        getFeatureFlagData(user?.email ?? "")
        fetchUserData()
        initFilters();
    }, [])


    return (
        <div className='p-4 content-wrapper'>
            <div className="user-management-section set-permission-main flag-main">
                <div className='set-permission-wrap mb-4'>
                    <div className="set-permission-top table-top-row">
                        <h4 className="mb-0">Feature Flag Settings</h4>
                        <div className='set-permission-top-right table-right-row'>
                            <div className='table-right-first mr-3 mt-1 mb-1'>
                                <div className="d-flex align-items-center table-search">
                                    <IconField iconPosition="right" className='user-input'>
                                        <InputIcon className="pi pi-search"></InputIcon>
                                        <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search by flag name" />
                                    </IconField>
                                </div>
                            </div>
                            <button className="outline-active-btn mt-1 mb-1" type="submit" onClick={onSubmit} >Save</button>
                        </div>
                    </div>
                    <div className="set-permission-table-wrap">
                        {/* <div className='d-flex justify-content-between permission-table-head'>
                            <h6>Flag Name</h6>
                            <h6>Flag Permission</h6>
                        </div> */}
                        <div className="set-permission-table">
                            <FeatureFlagDataTable filters={filters} flagArray={flagArray} setFlagArray={setFlagArray} />
                        </div>
                    </div>
                </div>
                <p className="mb-0 fix-note"><strong>NOTE:</strong> The changes you made in the settings will be reflected after you login again.</p>
            </div>
        </div>
    )
}

export default FlagSettings